import type {
  AudienciaPublic,
  CampanaEnvioPublic,
  EmisionActualizarInput,
  EmisionCrearInput,
  EnvioPublic,
  EstadoEnvio,
  FiltrosAudiencia,
  OpcionesEmisionPublic,
  PruebaEnvioInput,
} from '@app/shared';

import { api } from '../../../lib/api';

// ciclo-emisor, parte 2: las campañas de envío (backend: /campanas-envio).
export const emisionApi = {
  async list(): Promise<CampanaEnvioPublic[]> {
    const { data } = await api.get<{ campanas: CampanaEnvioPublic[] }>('/campanas-envio');
    return data.campanas;
  },

  async get(id: string): Promise<CampanaEnvioPublic> {
    const { data } = await api.get<{ campana: CampanaEnvioPublic }>(`/campanas-envio/${id}`);
    return data.campana;
  },

  async opciones(): Promise<OpcionesEmisionPublic> {
    const { data } = await api.get<OpcionesEmisionPublic>('/campanas-envio/opciones');
    return data;
  },

  async crear(input: EmisionCrearInput): Promise<CampanaEnvioPublic> {
    const { data } = await api.post<{ campana: CampanaEnvioPublic }>('/campanas-envio', input);
    return data.campana;
  },

  async actualizar(id: string, input: EmisionActualizarInput): Promise<CampanaEnvioPublic> {
    const { data } = await api.patch<{ campana: CampanaEnvioPublic }>(`/campanas-envio/${id}`, input);
    return data.campana;
  },

  async audiencia(filtros: FiltrosAudiencia): Promise<AudienciaPublic> {
    const { data } = await api.post<AudienciaPublic>('/campanas-envio/audiencia', { filtros });
    return data;
  },

  async envios(id: string, estado?: EstadoEnvio): Promise<EnvioPublic[]> {
    const { data } = await api.get<{ envios: EnvioPublic[] }>(`/campanas-envio/${id}/envios`, {
      params: estado ? { estado } : {},
    });
    return data.envios;
  },

  async prueba(input: PruebaEnvioInput): Promise<{ instancia: string }> {
    const { data } = await api.post<{ instancia: string }>('/campanas-envio/prueba', input);
    return data;
  },
};
